// extracted by mini-css-extract-plugin
export default {"breadcrumbsContent":"Breadcrumbs_breadcrumbsContent__VJ6MH"};